import { Box, Divider, Stack, Typography } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { Share } from '../../../Share';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';
import {
  ISupplier,
  getSupplierResource,
  supplierResourceFilterMapper,
} from 'Utils/suppliersResources';

interface ITitle {
  name: string;
  professionId: number;
  specialties: number[];
}
export const Title = ({ name, professionId, specialties }: ITitle) => {
  const { resources, subSpecialties } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();

  const supplierSpecialties = supplierResourceFilterMapper(
    subSpecialties as ISupplier,
    specialties
  );

  return (
    <Stack gap='8px'>
      <Stack
        direction='row'
        alignItems='center'
        gap={isDesktop ? '10px' : '6px'}
      >
        <Typography variant='h5'>{name}</Typography>
        <Divider
          orientation='vertical'
          sx={{ height: '20px', borderColor: '#2E3439' }}
        />
        <Typography variant='body2'>
          {getSupplierResource(resources.OCCUP, professionId)}
        </Typography>
        {!isDesktop && (
          <Box
            sx={{
              position: 'absolute',
              top: '10px',
              right: 0,
            }}
          >
            <Share />
          </Box>
        )}
      </Stack>
      <Typography variant='body6'>
        {supplierSpecialties.length > 0 &&
          Dictionary[DICTIONARY.Suppliers].resultPage.therapy.speciality}{' '}
        {supplierSpecialties.map((specialty: string, index: number) => {
          return `${specialty}${
            index < supplierSpecialties.length - 1 ? ', ' : ''
          }`;
        })}
      </Typography>
    </Stack>
  );
};
